import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">Terms of Service</h1>
      <div className="text-white/80 space-y-4 leading-relaxed text-sm">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>By using HubTune, you agree to these Terms of Service. Please read them carefully.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Payment and Liability</h2>
        <p>Tips on HubTune are voluntary payments made by listeners to support artists and are not purchases of goods or services. HubTune acts only as a technology and payment facilitator for these tip transactions.</p>
        <p>HubTune is not responsible for the content, actions, or obligations of artists. Any relationship, promise, or expectation between a listener and an artist is between those parties only.</p>
        <p>Payments may be temporarily held for processing, security checks, and payout settlement. Artist payouts are processed after internal review and may take 1–5 business days, depending on verification and risk checks.</p>
        <p>HubTune reserves the right to delay, hold, or suspend transactions in case of suspected fraud, abuse, policy violation, or legal risk. Any platform fees or processing charges, if applicable, will be shown clearly to users before confirming a payment.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Acceptable Use</h2>
        <p>You agree to use HubTune only for lawful purposes. You must not upload content that infringes on others' rights, is harmful, or violates applicable laws.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Account Responsibility</h2>
        <p>You are responsible for maintaining the confidentiality of your account and for all activities under your account.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Content</h2>
        <p>You retain ownership of the music and other content you upload. Uploading grants HubTune only the permission needed to host, store, stream, display, and promote that content on HubTune. Uploading does not transfer ownership. See the <Link to="/music-rights" className="text-red-400 underline hover:text-red-300">Music Rights &amp; Content Policy</Link> for practical upload guidance and reporting information.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Contact</h2>
        <p>
          You can contact HubTune at:
        </p>
        <p className="space-y-1">
          <span className="block"><span className="font-semibold">Name:</span> Ayush Kumar</span>
          <span className="block"><span className="font-semibold">Office Address:</span> 4351, Gali Number 8, Ajit Nagar, Gandhi Nagar, East Delhi, Delhi – 110031, India</span>
          <span className="block">
            <span className="font-semibold">Email:</span>{" "}
            <a
              href="mailto:ayushk76596@gmail.com"
              className="text-red-400 hover:text-red-300 underline"
            >
              ayushk76596@gmail.com
            </a>
          </span>
          <span className="block">
            <span className="font-semibold">Phone:</span>{" "}
            <a
              href="tel:+917080176462"
              className="text-red-400 hover:text-red-300 underline"
            >
              +91 7080176462
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default Terms;
